/* eslint-disable guard-for-in */
import React, { useState, useEffect, FormEvent } from 'react';

import { useParams } from 'react-router-dom';

import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';

import MaskedInput from 'react-text-mask';
import {
  Container,
  Sidebar,
  ContainerForm,
  Form,
  Card,
  Loading,
} from './styles';

import api from '../../services/api';
import product from '../../services/product';
import { HandleFormatMoney } from '../../services/utils';

interface Param {
  paymentId: string;
}

interface PaymentRequest {
  email: string;
  username: string;
  payment: {
    description: string;
    value: number;
    payment_type: string;
    payment_link: string;
    expired: boolean;
    payer_document: string;
    payer_name: string;
    paid: boolean;
    paid_at: Date;
    payment_id?: string;
  };
}

const Checkout: React.FC = () => {
  const [CardNumber, SetCardNumber] = useState('');
  const [Holder, SetHolder] = useState('');
  const [ExpirationDate, SetExpirationDate] = useState('');
  const [SecurityCode, SetSecurityCode] = useState('');
  const [payment, setPayment] = useState<PaymentRequest | null>(null);
  const [loading, setLoading] = useState(true);
  const [hasPayment, setHasPayment] = useState(false);
  const [successPayment, setSuccessPayment] = useState(false);
  const [expiredPayment, setExpiredPayment] = useState(false);
  const [error, setError] = useState('');

  const { paymentId } = useParams<Param>();

  function getBrand(cardNumber: string): string {
    const number = cardNumber.replace(/[^0-9]+/g, '');
    const cards = [
      { flag: 'VISA', reg: /^4[0-9]{12}(?:[0-9]{3})/ },
      { flag: 'MASTER', reg: /^5[1-5][0-9]{14}/ },
      { flag: 'Amex', reg: /^3[47][0-9]{13}/ },
      { flag: 'Diners', reg: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/ },
      { flag: 'Discover', reg: /^6(?:011|5[0-9]{2})[0-9]{12}/ },
      {
        flag: 'Elo',
        reg: /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})/,
      },
      { flag: 'Hipercard', reg: /^(606282\d{10}(\d{3})?)|(3841\d{15})/ },
      { flag: 'JCB', reg: /^(?:2131|1800|35\d{3})\d{11}/ },
    ];

    for (let i = 0; i < cards.length; i += 1) {
      const current = cards[i];

      if (current.reg.test(number)) {
        return current.flag;
      }
    }

    return 'Visa';
  }

  async function getPayment(paymentIdentifier: string): Promise<void> {
    try {
      setLoading(true);
      setPayment(null);
      const { data } = await api.get<PaymentRequest>(
        `payment_card/show?payment_link=${paymentIdentifier}`,
      );

      if (data.payment.paid) {
        setHasPayment(true);
      }

      if (data.payment.expired) {
        setExpiredPayment(true);
      }

      setPayment(data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      window.location.href = 'https://app.qesh.ai';
    }
  }

  useEffect(() => {
    getPayment(paymentId);
  }, [paymentId]);

  async function processPayment(e: FormEvent<HTMLFormElement>): Promise<void> {
    e.preventDefault();
    setError('');

    const Brand = getBrand(CardNumber);
    const dataPayment = {
      CardNumber: CardNumber.replace(/[\s]/g, ''),
      Holder,
      ExpirationDate,
      SecurityCode,
      Brand,
    };

    const values = Object.values(dataPayment);
    for (let i = 0; i < values.length; i += 1) {
      const current = values[i];
      if (current.length <= 0) {
        setError('Todos os campos são obrigatórios');
        return;
      }
    }

    try {
      setLoading(true);
      const { data } = await api.post(
        `payment_card/process/${paymentId}`,
        dataPayment,
      );

      if (data[0] && data[0].Code) {
        setLoading(false);
        setError(data[0].Message);
        return;
      }

      setSuccessPayment(true);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setError(
        'Transação recusada por alguma restrição. Confira os dados informados ou escolha outro cartão ou forma de pagamento.',
      );
    }
  }

  return (
    <>
      <Container>
        <Loading hasLoading={loading}>
          <section />
          {/* <img
            src="https://app.qesh.ai/static/media/qesh-logo-color-vtc.85e4545b.svg"
            alt="Qesh"
          /> */}
          <span />
          <div />
        </Loading>

        {payment && (
          <>
            <ContainerForm>
              {!successPayment && !hasPayment && !expiredPayment ? (
                <>
                  <Form onSubmit={processPayment}>
                    <div>
                      <MaskedInput
                        type="text"
                        name="CardNumber"
                        placeholder="Número do cartão"
                        value={CardNumber}
                        onChange={(e) => SetCardNumber(e.target.value)}
                        mask={[
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          ' ',
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          ' ',
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          ' ',
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                        ]}
                      />
                    </div>
                    <div>
                      <input
                        type="text"
                        placeholder="Titular do cartão"
                        name="Holder"
                        value={Holder}
                        onChange={(e) => SetHolder(e.target.value)}
                      />
                    </div>
                    <section>
                      <MaskedInput
                        type="text"
                        placeholder="Validade"
                        name="ExpirationDate"
                        value={ExpirationDate}
                        onChange={(e) => SetExpirationDate(e.target.value)}
                        mask={[/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                      />
                      <input
                        type="text"
                        placeholder="CVV"
                        name="SecurityCode"
                        value={SecurityCode}
                        maxLength={4}
                        onChange={(e) => SetSecurityCode(e.target.value)}
                      />
                    </section>

                    <div>
                      <button type="submit">Realizar Pagamento</button>
                    </div>
                    {!!error && (
                      <div
                        style={{
                          border: '1px solid #ff9377',
                          padding: 12,
                          borderRadius: 4,
                          color: '#c5310a',
                        }}
                      >
                        {error}
                      </div>
                    )}
                  </Form>
                  <Card>
                    <Cards
                      cvc={SecurityCode}
                      expiry={ExpirationDate}
                      name={Holder}
                      number={CardNumber}
                    />
                  </Card>
                </>
              ) : (
                <>
                  {!successPayment && !expiredPayment ? (
                    <div
                      style={{
                        width: '100%',
                        background: '#f7f7f7',
                        borderRadius: 8,
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                      }}
                    >
                      <h3
                        style={{
                          fontFamily: 'Barlow',
                          fontWeight: 300,
                          marginBottom: 30,
                          paddingBottom: 10,
                          borderBottom: '1px solid #ccc',
                        }}
                      >
                        Este pagamento já foi quitado
                      </h3>
                      <p
                        style={{
                          fontFamily: 'Barlow',
                          fontWeight: 300,
                          marginBottom: 30,
                        }}
                      >
                        Para maiores informações entre em contato com o
                        cobrador.
                      </p>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </>
              )}

              {expiredPayment && (
                <div
                  style={{
                    width: '100%',
                    background: '#f7f7f7',
                    borderRadius: 8,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <h3
                    style={{
                      fontFamily: 'Barlow',
                      fontWeight: 300,
                      marginBottom: 30,
                      paddingBottom: 10,
                      borderBottom: '1px solid #ccc',
                    }}
                  >
                    Este pagamento expirou
                  </h3>
                  <p
                    style={{
                      fontFamily: 'Barlow',
                      fontWeight: 300,
                      marginBottom: 30,
                    }}
                  >
                    Para maiores informações entre em contato com o
                    cobrador.
                  </p>
                </div>
              )}

              {successPayment && (
                <div
                  style={{
                    width: '100%',
                    background: '#f7f7f7',
                    borderRadius: 8,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <h3
                    style={{
                      fontFamily: 'Barlow',
                      fontWeight: 300,
                      marginBottom: 30,
                      paddingBottom: 10,
                      borderBottom: '1px solid #ccc',
                      fontSize: 30,
                    }}
                  >
                    Pagamento aprovado!
                  </h3>
                  <p
                    style={{
                      fontFamily: 'Barlow',
                      fontWeight: 300,
                      marginBottom: 30,
                    }}
                  >
                    {payment.payment.payer_name}, recebemos o seu pagamento!
                  </p>
                </div>
              )}
            </ContainerForm>
            <Sidebar>
              <header>
                <img
                  className="responsive-image"
                  // https://app.qesh.ai/logo_qesh.png
                  src={product.logo}
                  alt={product.name}
                  style={{ width: product.width, }}
                />
              </header>
              <section>
                <span />
                <h3>{payment.payment.description}</h3>
              </section>
              <section>
                <span>Cobrança criada por</span>
                <h4>{payment.username}</h4>
              </section>
              <section>
                <span>Para</span>
                <h4>{payment.payment.payer_name}</h4>
              </section>
              <section>
                <span>Metodo de pagamento</span>
                <h4>
                  {payment.payment.payment_type === 'CreditCard'
                    ? 'Cartão de Crédito'
                    : 'Cartão de Débito'}
                </h4>
              </section>
              <footer>
                <span>Valor</span>
                <div>{HandleFormatMoney(payment.payment.value)}</div>
              </footer>
            </Sidebar>
          </>
        )}
      </Container>
    </>
  );
};

export default Checkout;
